import { getInternalApiInstance } from "./base";

export interface InitiateDataExportParams {
    userId: string;
    dataTypes: string[];
    startDate?: string;
    endDate?: string;
}

export interface InitiateDataExportResponse {
    exportId: string;
    downloadPageUrl: string;
    message: string;
}

export const initiateDataExport = async (
    params: InitiateDataExportParams
): Promise<InitiateDataExportResponse> => {
    const api = await getInternalApiInstance();
    try {
        const res = await api.post("/admin/data-export/initiate", params);
        return res.data.data;
    } catch (error) {
        throw error;
    }
};
